<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="searchRecords()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_SEARCH') }}</span>
                </b-button>
                <b-button
                  v-if="$ability.can(constants.action.permissionProcessAdd, constants.resource.process) && user_type !== 'super-admin'"
                  v-b-modal.modal-role
                  variant="primary"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_PROCESS') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="tableFields"
          :items="processesData"
        >
          <template #cell(companyname)="data">
            {{ data.item.get_company ? data.item.get_company.name : '' }}
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionProcessEdit, constants.resource.process)"
              v-b-modal.modal-role-edit
              icon="EyeIcon"
              @click="goToDetails(data.item.id)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <add-process-modal
          :modal-loads="modalLoader"
          :reload-method="getProcesses"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination,
} from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import AddProcessModal from './AddProcessModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    AddProcessModal,
  },
  data() {
    return {
      loader: false,
      processesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addLetterInput: {
        id: 0,
        name: '',
        description: '',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      templateId: 0,
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
      wordFile: false,
      finalStep: false,
      showVariables: false,
      busy: false,
      clicked: false,
      searchRun: false,
    }
  },
  computed: {
    tableFields() {
      let fields = []
      if (this.user_type === 'super-admin') {
        fields = [
          { key: 'id', sortable: true },
          { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
          { key: 'type', sortable: true, label: i18n.t('DEBTIA_TYPE') },
          // { key: 'companyname', sortable: true, label: i18n.t('DEBTIA_COMPANY_NAME') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      } else {
        fields = [
          { key: 'id', sortable: true },
          { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
          { key: 'type', sortable: true, label: i18n.t('DEBTIA_TYPE') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      }
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getProcesses()
        }
      },
    },
    currentPage: {
      handler() {
        this.getProcesses()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getProcesses()
      },
    },
  },
  created() {
    this.getProcesses()
    this.actionColumn()
  },
  methods: {
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getProcesses()
      }
    },
    async getProcesses() {
      if (this.user_type === 'super-admin') {
        this.isSuperAdmin = true
      } else {
        this.isSuperAdmin = false
      }
      this.loader = true
      const processes = await axios.get(`/process/list?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}`)
      this.loader = false
      if (processes.status) {
        // console.log('processes.data.data.api_tokens.data ', processes.data.data.processes.data)
        this.processesData = processes.data.data.processes.data
        this.totalPages = processes.data.data.processes.total
        this.from = processes.data.data.processes.from
        this.to = processes.data.data.processes.to
        this.currentPage = processes.data.data.processes.current_page
        this.loader = false
      }
    },
    goToDetails(id) {
      this.$router.push(`/process/view/${id}`)
    },
    letterTemplate(item) {
      this.modalLoader = true
      this.wordFile = !this.wordFile
      this.finalStep = !this.finalStep
      this.showVariables = !this.showVariables
      this.editData = item
      this.modalLoader = false
      this.clicked = !this.clicked
    },
    async deleteTemplate(id) {
      this.loader = true
      const templates = await axios.post(`${constants.baseUrl}/letters/delete`,
        { templateID: id })
      if (templates.status) {
        this.getProcesses()
      }
      this.loader = false
    },
    confirmDeleteText(id, name) {
      // methodId
      const question = ` '${name}' ?`
      this.$swal({
        title: i18n.t('DEBTIA_WARNING'),
        text: i18n.t('DEBTIA_DELETION_MSG') + question,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteTemplate(id)
        }
      })
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionProcessEdit, this.constants.resource.process)) {
        if (this.user_type !== 'super-admin') {
          this.tableFields.splice(2, 1)
        } else {
          this.tableFields.splice(3, 1)
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
